module.exports = __webpack_public_path__ + "img/st.d5cf2a1d.svg";